import React from 'react';
import { CircularProgress, Typography } from '@material-ui/core';
import { Box } from "@mui/material";
import { tUi } from '../../../../../../../utils/dq_lc';
import { PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT_VERBOSE } from "../../../../../../../utils/constants";
import { V2_SUPPORTED_SLIDE_LAYOUTS } from '../../../../utils/LearnTab/preview.constants';
import { getSlideLayout } from '../../../../utils/LearnTab/preview.utils';
import SlideEngine from '../Slides/SlideEngine.comp';

const ContentArea = ({
    data,
    nav,
    editor,
    tts,
    classes,
    isCollapsed = false,
}) => {
    const currentLayout = getSlideLayout(nav.currentSessionSlide);
    const isV2SupportedLayout = V2_SUPPORTED_SLIDE_LAYOUTS.includes(currentLayout) || Boolean(nav.currentSessionSlide?.slide_type || nav.currentSessionSlide?.question || nav.currentSessionSlide?._pbdq_origin);

    return (
        <Box className={classes.slidesContainer} sx={{
            padding: { xs: '0px', sm: '0 20px 20px 20px' },
            width: { xs: '90vw', sm: '100%' },
            paddingLeft: { xs: '0px', sm: '72px', md: isCollapsed ? '100px' : '0px' },
            paddingRight: { xs: '0px', sm: '72px', md: '0px' },
        }}>
            {data.slidesLoading ? (
                <Box style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '300px', width: '100%' }}>
                    <CircularProgress size={40} style={{ color: '#ED6628', marginBottom: '20px' }} />
                    <Typography variant="body1" style={{ color: '#555' }}>
                        {tUi('preview.loadingSlides', data.uiLocale)}
                    </Typography>
                </Box>
            ) : nav.currentSegmentSlides.length > 0 && nav.currentSessionSlide ? (
                <Box style={{ alignSelf: 'stretch', width: '100%', height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                    {isV2SupportedLayout ? (
                        <SlideEngine
                            slide={nav.currentSessionSlide}
                            highlightWord={tts.highlightWordRenderer}
                            skipTitleSpeech={tts.skipTitleSpeech}
                            isEditMode={editor.isEditMode}
                            slideEdits={editor.currentSlideEdits}
                            showEnglishContent={editor.showEnglishContent}
                            onSaveEdit={editor.handleSaveEdit}
                            onResetEdit={editor.handleResetEdit}
                            videoUrl={data.introVideoUrl}
                            videoSubtitles={data.introVideoVtt}
                            langCode={data.currentDisplayLanguage ? data.currentDisplayLanguage.split('-')[0] : 'en'}
                            uiLocale={data.uiLocale}
                            onCancelEdit={() => {}}
                            onNextSlide={nav?.handleNextSlide}
                            onPollSubmit={nav?.recordPollSubmission}
                            pollResponses={nav?.pollResponses}
                            pollFeedback={nav?.currentPollFeedback}
                            isPollCorrect={nav?.isPollCorrect}
                        />
                    ) : (() => {
                        const SlideComponent = PBDQ3_PROGRAM_SESSION_CONTENT_LAYOUT_VERBOSE[nav.currentSessionSlide.SlideLayout];
                        if (!SlideComponent) {
                            return (
                                <Typography variant="h6" color="error">
                                    {tUi('preview.error.slideLayoutNotFound', data.uiLocale)}
                                </Typography>
                            );
                        }
                        return (
                            <SlideComponent
                                title={nav.currentSessionSlide.SlideTitle}
                                slideContent={Array.isArray(nav.currentSessionSlide.SlideContent) ? nav.currentSessionSlide.SlideContent : [nav.currentSessionSlide.SlideContent]}
                                images={nav.currentSessionSlide.Images || []}
                            />
                        );
                    })()}
                </Box>
            ) : (
                <Typography variant="h6" style={{ color: '#555' }}>
                    No slides available for this segment
                </Typography>
            )}
        </Box>
    );
};

export const PreviewSlideArea = ContentArea;
export { ContentArea };
export default ContentArea;
